module.exports = __webpack_public_path__ + "img/cach-gold.0bc7bb37.svg";